<div
  class="ui attached segment"
  appMargin
  marginT="5"
  [class.loading]="pending"
>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <div fxFlex="25%">
      {{ alert?.alertScenarioName }}
    </div>
    <div fxFlex="30%">
      {{ alert?.description }}
    </div>
    <div fxFlex="20%">
      <div class="icons">
        <img
          src="assets/icons/envelope-sm.svg"
          alt=""
          *ngIf="alert?.email?.length"
        />
        <img
          src="assets/icons/slack-sm.svg"
          alt=""
          *ngIf="alert?.slack?.length"
        />
      </div>
    </div>
    <div fxFlex="10%">
      <sui-checkbox
        class="toggle enable_on_save"
        [(ngModel)]="isAlertActive"
        (click)="enableOrDisableAlert()"
      ></sui-checkbox>
    </div>
    <div fxFlex="14%">
      <div class="ui mini basic primary dropdown" suiDropdown>
        <!-- <img src="assets/icons/Button.svg" alt="" /> -->
        <esl-button
          buttonType="primary"
          buttonSize="small"
          buttonState="outline"
          buttonActionState="default"
          [hasLine]="true"
          [hasSuffixIcon]="true"
          [buttonMenu]="'dropdownMenu'"
          [hasDropdown]="true"
          [isClickable]="true"
        ></esl-button>
        <div class="left menu" suiDropdownMenu>
          <div class="item" (click)="viewAlert()">View Alert</div>
          <div
            *ngIf="
              checkPermission({
                id: 'APPLICATION_SECURITY_MODULE',
                action: 'edit'
              })
            "
            class="item"
            (click)="editAlertModal()"
          >
            Edit Alert
          </div>
          <div
            *ngIf="
              checkPermission({
                id: 'APPLICATION_SECURITY_MODULE',
                action: 'remove'
              })
            "
            class="item"
            (click)="deleteAlert()"
          >
            Delete Alert
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
